import { usePaymentTerm } from "@faire/deprecated-retailer-visitor-shared/hooks/retailer/usePaymentTerm";
import { useRetailer } from "@faire/deprecated-retailer-visitor-shared/hooks/retailer/useRetailer";
import { getSettingOpenWithFaireOfferedTerms } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingOpenWithFaireOfferedTerms";
import { useOpenWithFaireApplicationStatus } from "@faire/deprecated-retailer-visitor-shared/stores/domain/OpenWithFaire/useOpenWithFaireApplicationStatus";
import { CurrencyUnit } from "@faire/web-api--source/faire/currency/CurrencyUnit";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
import { IOpenWithFaireCreditOfferRange } from "@faire/web-api--source/indigofair/data/IOpenWithFaireCreditOfferRange";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";

const DEFAULT_TERMS_LIMIT_RANGE = IOpenWithFaireCreditOfferRange.build({
  min_terms_offered: IFaireMoney.build({
    amount_cents: 500000,
    currency: CurrencyUnit.USD,
  }),
  medium_terms_offered: IFaireMoney.build({
    amount_cents: 1000000,
    currency: CurrencyUnit.USD,
  }),
  max_terms_offered: IFaireMoney.build({
    amount_cents: 2000000,
    currency: CurrencyUnit.USD,
  }),
});

export const useOpenWithFaireTerms = () => {
  const { retailer } = useRetailer();
  const { isRetailerOnNetTerms } = usePaymentTerm();
  const { isEligible } = useOpenWithFaireApplicationStatus();

  const businessType =
    retailer?.business_category ?? IRetailer.BusinessCategory.BRICK_AND_MORTAR;
  const offeredTermsRange =
    getSettingOpenWithFaireOfferedTerms()?.[businessType] ??
    DEFAULT_TERMS_LIMIT_RANGE;
  return {
    offeredMinTerms:
      offeredTermsRange.min_terms_offered ??
      DEFAULT_TERMS_LIMIT_RANGE.min_terms_offered!,
    offeredMediumTerms:
      offeredTermsRange.medium_terms_offered ??
      DEFAULT_TERMS_LIMIT_RANGE.medium_terms_offered!,
    offeredMaxTerms:
      offeredTermsRange.max_terms_offered ??
      DEFAULT_TERMS_LIMIT_RANGE.max_terms_offered!,
    isEligibleWithNoInitialTerms: isEligible && !isRetailerOnNetTerms,
  };
};
